import React from "react";
import { LEGAL } from "../constants/legal";

// Grievance Officer / privacy contact — India IT (Intermediary Guidelines) Rules 2021
// r.3(2) and DPDP Rules 2025. Details come from constants/legal.js.
export default function GrievanceOfficer() {
  const g = LEGAL.grievanceOfficer;
  return (
    <div id="grievance">
      <h3>{g.title}</h3>
      <p>
        For complaints about content, your account, or how we handle your personal data, contact us using the
        details below. We acknowledge every complaint within 24 hours and resolve it within 15 days.
      </p>
      <ul>
        {g.name && <li><strong>Name:</strong> {g.name}</li>}
        <li><strong>Email:</strong> <a href={`mailto:${g.email}`}>{g.email}</a></li>
        {g.phone && <li><strong>Phone:</strong> {g.phone}</li>}
        {LEGAL.postalAddress && <li><strong>Address:</strong> {LEGAL.operator}, {LEGAL.postalAddress}</li>}
      </ul>
    </div>
  );
}
